import React from 'react'
import './User.css'
import ATSearchBox from '../../common/formComponent/ATSearchBox'
import ATTextButton from '../../common/formComponent/ATTextButton'
import ATSwitch from '../../common/formComponent/ATSwitch'
import AppTablePagination from '../../common/table/AppTablePagination'
import ATModuleMessage from '../../common/message/ATModuleMessage'
import ATLoaderContainer from '../../common/loaderContainer/ATLoaderContainer'
import { UserListColumn } from '../userManagementConstants'
import { Modal } from 'react-bootstrap'
import AddUserPopup from './addUser/AddUserPopup'
import UserActivityLogModal from './activityLog/UserActivityLogModal'
import useAddUserHook from '../../../customHooks/usermanagement/useAddUserHook'
import ATConfirmBox from '../../common/confirmBox/ATConfirmBox'
import Authorize from '../../common/auth/Authorize'
import { getWidgetMapping } from '../../../utils/authUtil/AuthUtil'
import { PERMISSIONS, WIDGET_TYPE } from '../../common/auth/AuthorizeConstant'

const User: React.FC = () => {
  const {
    t,
    showAddUserPopUp,
    showAddUser,
    closeAddUserPopUp,
    onStatusChangeHandler,
    queryHandler,
    handleResetFilter,
    handlePageSize,
    fetchData,
    onEditHandler,
    onStatusHandler,
    status,
    query,
    pageNumber,
    limit,
    usersList,
    isEdit,
    userId,
    handleApplyFilter,
    updateUserStatus,
    getUserModalMessage,
    updateUserStatusPopUp,
    updateUserAccountState,
    showActivityLog,
    activityLogUserId,
    activityLogUserName,
    onViewActivityLogHandler,
    onHideActivityLog,
  } = useAddUserHook()

  const getJSX = () => {
    if (usersList?.data?.data?.length === 0) {
      return (
        <ATLoaderContainer>
          <ATModuleMessage />
        </ATLoaderContainer>
      )
    } else if (usersList?.isSuccess && usersList?.data?.data?.length !== 0) {
      return (
        <AppTablePagination
          data={usersList?.data || []}
          limit={limit}
          handlePageChange={fetchData}
          currentPage={pageNumber}
          handlePageSize={handlePageSize}
          columns={UserListColumn(
            onStatusHandler,
            onEditHandler,
            onViewActivityLogHandler,
          )}
          minHeight="calc(100vh - 310px)"
        />
      )
    }
  }

  return (
    <div className="container-fluid h-100 p-2 d-flex flex-column">
      <div className="d-flex justify-content-between py-2 align-items-center">
        <div className="d-flex gap-3 align-items-center">
          <div className="col-md-8">
            <ATSearchBox
              name="users"
              handleChange={queryHandler}
              onBlurHandler={() => null}
              searchInput={query}
              placeholder={t('userRoles.search_users')}
            />
          </div>
          <ATTextButton
            title={t('common.apply')}
            onPressHandler={handleApplyFilter}
          />
          <ATTextButton
            variant="link"
            title={t('common.reset')}
            onPressHandler={handleResetFilter}
          />
        </div>
        <div className="d-flex gap-4 me-4">
          <div>
            <ATSwitch
              callback={onStatusChangeHandler}
              activeIndex={status ? 0 : 1}
              classname={'user-switch'}
              segments={[
                {
                  label: t('common.active'),
                  value: true,
                },
                {
                  label: t('common.inactive'),
                  value: false,
                },
              ]}
              disabled={false}
            />
          </div>
          <div>
            <Authorize
              widgetId={getWidgetMapping(PERMISSIONS.ADD_USER)}
              widgetType={WIDGET_TYPE.BUTTON}
            >
              <ATTextButton
                title={t('userRoles.add_user')}
                onPressHandler={showAddUserPopUp}
              />
            </Authorize>
          </div>
        </div>
      </div>
      <div className="row flex-1">
        <Authorize
          widgetId={getWidgetMapping(PERMISSIONS.VIEW_USERS)}
          widgetType={WIDGET_TYPE.VIEW}
        >
          {getJSX()}
        </Authorize>
      </div>
      <Modal show={showAddUser} className="modal-xl">
        <AddUserPopup
          onCloseModal={closeAddUserPopUp}
          isEdit={isEdit}
          userId={userId}
        />
      </Modal>
      <ATConfirmBox
        showModal={updateUserStatus}
        modalTitle={t('userRoles.update_user_status')}
        modalMessage={getUserModalMessage()}
        onCancel={updateUserStatusPopUp}
        onSave={updateUserAccountState}
      />
      <UserActivityLogModal
        show={showActivityLog}
        header={t('userRoles.activity_log')}
        selectedUserId={activityLogUserId}
        userName={activityLogUserName}
        onHide={onHideActivityLog}
      />
    </div>
  )
}

export default User
